<app-sidebar></app-sidebar>
<app-quote></app-quote>